const routes = {
    HOME         : '/',
    CONNEXION    : '/connexion',
    DASHBOARD    : '/dashboard',
    MANAGEHOOTS  : '/dashboard/hootin',
    MANAGEPROFILE: '/manage_profile',
    PROFILE      : '/profile',
    HOOT         : '/hoot'
};

export default routes;